import AiTrainingDesign from './src/main';

/* istanbul ignore next */
AiTrainingDesign.install = function(Vue) {
  Vue.component(AiTrainingDesign.name, AiTrainingDesign);
};

export default AiTrainingDesign;
